<template>
  <div>
    <el-container class="container">
      <el-header class="header" style="height:100px">
        <div class="headerDiv">
          <div class="logo">
            <img :src="imgLogin" />
          </div>
          <div class="tabImg">
            <div class="tabImgs">
              <div v-for="(v) in navData" :key="v.id" @click="tab(v.id)">
                <!-- <div> -->
                <img :src="activeIndex==v.id?v.imgUrlC:v.imgUrl" :class="activeIndex==v.id?'navDataAc':''" alt />
                <!-- </div> -->
                <div v-if="v.id==6&&activeIndex!=v.id">{{v.title}}</div>
              </div>
            </div>
          </div>
          <div class="headerRight">
            
            <div class="headerRightTop">
              <div @click="help">
                <i class="iconfont icon-bangzhu"></i>
                <span>帮助</span>
              </div>
              
              <div @click="about">关于</div>
              <div @click="outFn()">退出</div>
            </div>
            <div class="headerRightBotton">
              <span @click="HrefClick" style=""  style="margin-right:1rem;display:flex;font-size: 14px;">
                  <p style="margin:0">新版</p>
                  <p style="margin:0 3px;">/</p>
                  <p style="color:#246DEB;margin:0">切换旧版</p>
              </span>
              <div>
                <i class="iconfont icon-renyuan-05"></i>
                <span style="font-size: 1.4rem;">{{name}}</span>
              </div>
              <!-- <div></div> -->
              <div @click="msgFn">
                <i class="iconfont icon-xiaoxi"></i>
                <span style="font-size: 1.4rem;">消息</span>
              </div>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside style="width: 260px;">
          <!-- <div class="asideWorke" :class="onclass==true ? 'active' : ''">
            <div @click="workeFn()">
              <i class="iconfont icon-gongzuotai"></i>
              <span>工作台</span>
            </div>
          </div>-->

          <el-menu
            :default-active="activerouter"
            :collapse-transition="false"
            ref="menu"
            background-color="#2A354D"
            text-color="#fff"
            active-text-color="#fff"
            router
            @select="handleSelect"
          >
            <!-- <el-menu-item index="/workebench">
              <i class="iconfont icon-gongzuotai"></i>
              <span slot="title">工作台</span>
            </el-menu-item> -->
            <template v-for="v in menu">
              <template v-if="v.children">
                <el-submenu :index="v.path">
                  <template slot="title">
                    <img
                      :src="v.icon"
                      alt
                      srcset
                      style=" width:14px;height:14px; color: white;margin-right:5px"
                    />
                    <span slot="title">{{ v.title }}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item
                      v-for="vv in v.children"
                      :index="'/' + vv.path"
                      :key="vv.id"
                    >{{ vv.title }}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :index="'/'+v.path">
                  <img
                    :src="v.icon"
                    alt
                    srcset
                    style=" width:14px;height:14px; color: white;margin-right:5px"
                  />
                  <span slot="title">{{ v.title }}</span>
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </el-aside>
        <el-main>
          <el-drawer
            title="消息"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="msgHandleClose"
          >
            <el-divider></el-divider>
            <div class="msgBox">
              <div v-for="v in noteDrawer" :key="v.id" class="msgBoxitem">
                <div>短信余额不足提醒</div>
                <div>
                  <span>{{v.Name}}</span>
                  <span>
                    <span>余额:</span>
                    <span v-if="v.charge==1">{{v.Balance}}</span>
                    <span v-if="v.charge==2">{{v.charge_time}}</span>
                    <span  v-if="v.charge==1">元</span>
                  </span>
                </div>
                <div>
                  <span>ID: {{v.ScenicID}}</span>
                  <span>短信类型: {{v.charge=='2'?'计时':'计费'}}</span>
                </div>
              </div>
            </div>
          </el-drawer>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { outPost, signPost,getJfyInfo ,getJfyScenicWarning} from "@/request/logins.js";
export default {
  data() {
    return {
      navPar: {
        username: "",
        password: ""
      },
      token: "",
      drawer: false,
      direction: "rtl",
      collapsed: false,
      imgLogin: require("../images/home/login.jpg"),
      noteDrawer: [
       
      ],
      navData: [
        {
          id: "1",
          imgUrl: require("../images/home/jqh.png"),
          imgUrlC: require("../images/home/jq1.jpg"),
          title: "景区管理"
        },
        {
          id: "2",
          imgUrl: require("../images/home/fxh.png"),
          imgUrlC: require("../images/home/fxs1.jpg"),
          title: "分销商管理"
        },
        {
          id: "3",
          imgUrl: require("../images/home/cwh.png"),
          imgUrlC: require("../images/home/cw1.jpg"),
          title: "财务管理"
        },
        {
          id: "4",
          imgUrl: require("../images/home/sph.jpg"),
          imgUrlC: require("../images/home/sp1.jpg"),
          title: "视频管理"
        },
        {
          id: "5",
          imgUrl: require("../images/home/xth.jpg"),
          imgUrlC: require("../images/home/xt1.jpg"),
          title: "系统设置"
        },
        {
          id: "6",
          imgUrl: require("../assets/dq1.png"),
          imgUrlC: require("../assets/dq.png"),
          title: "雪场大全"
        }
      ],
      // 景区管理
      scenicMenu: [
        {
          id: 1,
          title: "工作台",
          path: "workebench",
          icon: require("../images/menu/jqgl.png")
        },
        {
          id: 2,
          title: "景区列表",
          path: "scenicMange",
          icon: require("../images/menu/jqgl.png")
        },
        {
          id: 3,
          title: "景区产品列表",
          path: "scenicbalance",
          icon: require("../images/menu/jqgl.png")
        },
        {
          id: 4,
          title: "短信模板",
          path: "smsTemplate",
          icon: require("../images/menu/jqgl.png")
        },
        {
          id: 5,
          title: "退款短信模板",
          path: "smsrefund",
          icon: require("../images/menu/jqgl.png")
        }
        // 
      ],
      // 分销商
      retailerMenu: [
      // {
      //     id: 1,
      //     title: "工作台",
      //     path: "workebench",
      //     icon: require("../images/menu/jqgl.png")
      //   },
        {
          id: 2,
          title: "一级分销商列表",
          path: "oneFxs",
          icon: require("../images/menu/yjfxs.png")
        },
        {
          id: 3,
          title: "二级分销商列表",
          path: "twoFxs",
          icon: require("../images/menu/ejfxs.png")
        },
        // {
        //   id: 3,
        //   title: "分销商审核",
        //   path: "fxsVerify",
        //   icon: require("../images/menu/fxssh.png")
        // }
      ],
      // 设置
      setMenu: [
      // {
      //     id: 1,
      //     title: "工作台",
      //     path: "workebench",
      //     icon: require("../images/menu/jqgl.png")
      //   },
        {
          id: 2,
          title: "修改密码",
          path: "changeMm",
          icon: require("../images/menu/mm.png")
        },
        {
          id: 3,
          title: "权限管理",
          path: "rightMange",
          icon: require("../images/menu/qx.png"),
          children: [
            {
              id: 3 - 1,
              title: "管理员管理",
              path: "adminMange"
            },
            {
              id: 3 - 2,
              title: "角色管理",
              path: "roleMange"
            },
            {
              id: 3 - 3,
              title: "Boss管理",
              path: "bossMange"
            }
          ]
        },
        {
          id: 4,
          title: "消息通知",
          path: "news",
          icon: require("../images/menu/tz.png")
        },
        {
          id: 5,
          title: "在线客服设置",
          path: "customer",
          icon: require("../images/menu/customer.png")
        },
        // {
        //   id: 6,
        //   title: "合作商设置",
        //   path: "partners",
        //   icon: require("../images/menu/customer.png")
        // }
      ],
      // 财务
      financeMenu: [
        {
          id: 5,
          title: "短信充值审核",
          path: "noteDeposit",
          icon: require("../images/menu/dxcz.png")
        }
      ],
      // 视频
      videoMenu: [
      // {
      //     id: 1,
      //     title: "工作台",
      //     path: "workebench",
      //     icon: require("../images/menu/jqgl.png")
      //   },
        {
          id: 2,
          title: "视频列表",
          path: "videoList",
          icon: require("../images/menu/splb.png")
        },
        {
          id: 3,
          title: "视频设置",
          path: "vedioSet",
          icon: require("../images/menu/spsz.png")
        }
      ],
      navList: [], // 菜单
      menu: [], // 菜单
      activeIndex: "1",
      name:'',
      activeRouter:'/workebench'
    };
  },
  created(){
    let data = {
      token:sessionStorage.getItem("Token")
    }
    getJfyInfo(data).then(res=>{
      if(res.data.status=='OK'){
        this.name = res.data.data.UserName
      }
    })
    if(window.sessionStorage.getItem('index')){
        this.tab(window.sessionStorage.getItem('index')) 
    }else{
      this.tab('1')
    }
  },
  mounted() {
    // this.activeIndex = "";
    this.token = sessionStorage.getItem("Token");
    // this.menu = JSON.parse(window.localStorage.getItem("menue"));
    // console.log(this.menu);
    // this.getNav();
  },
  methods: {
    HrefClick(){
      let href = 'http://www.softykt.net/'
      window.open(href)
    },
    help(){
      window.location.href = 'http://ski.beebird.com.cn/Public/dowloadhelp/jfy.rar'
    },
    about(){
      window.open('http://www.softykt.cn/')
    },
    // 点击工作台
    workeFn() {
      this.onclass = true;
      this.$router.push("/workebench");
    },
    // 点击退出
    outFn() {
      let updata = {
        token: this.token
      };
      outPost(updata).then(res => {
        this.$message.success('退出成功')
        sessionStorage.clear();
        this.$router.push("/superlogin");
      });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    // 顶部导航栏切换
    tab(id) {
      // this.activerouter = '/workebench'
      if(id=='6'){
        const token = sessionStorage.getItem('Token') || '';
        if (!token) {
          this.$router.push('/superlogin');
          return false;
        }
        this.activeIndex = 1;
        const snowlistUrl = `http://nowadmin.softykt.cn/snowlist?token=${encodeURIComponent(token)}`;
        window.open(snowlistUrl, '_blank');
        this.$nextTick(function(){
          this.$refs.menu.activeIndex = '/workebench';
        });
        this.$router.push('/workebench');
        this.menu = this.scenicMenu;
        return false;
      }
      this.navList = JSON.parse(window.localStorage.getItem("menue"));
      this.activeIndex = id;
      window.sessionStorage.setItem('index',this.activeIndex)
      
      
      if (id == 1) {
        this.$router.push('/workebench')
        this.$nextTick(function(){
          this.$refs.menu.activeIndex = '/workebench';
        })
        // 景区管理
        // this.menu = Array(this.navList[1]);
        this.menu = this.scenicMenu;
      }
      if (id == 2) {
        this.$router.push('/oneFxs')
        this.$nextTick(function(){
          this.$refs.menu.activeIndex = '/oneFxs';
        })
        // 分销商管理
        // this.menu = Array(this.navList[2]);
        // console.log(this.menu);
        this.menu = this.retailerMenu;
      }
      if (id == 3) {
        // 财务管理
        this.$router.push('/noteDeposit')
        this.$nextTick(function(){
          this.$refs.menu.activeIndex = '/noteDeposit';
        })
        this.menu = this.financeMenu;
      }
      if (id == 4) {
        this.$router.push('/videoList')
        this.$nextTick(function(){
          this.$refs.menu.activeIndex = '/videoList';
        })
        // 视频管理
        this.menu = this.videoMenu;
      }
      if (id == 5) {
        this.$router.push('/changeMm')
        this.$nextTick(function(){
          this.$refs.menu.activeIndex = '/changeMm';
        })
        // 系统管理
        this.menu = this.setMenu;
      }

    },
    // 点击消息
    msgFn() {
      let data = {
        token:sessionStorage.getItem("Token")
      }
      getJfyScenicWarning(data).then(res=>{
        if(res.data.status=='ok'){
          this.noteDrawer = [...res.data.result.data1,...res.data.result.data]
        }
      })
      this.drawer = true;
    },
    msgHandleClose(done) {
      done();
    },
    handleSelect(keyPath){
      console.log(keyPath)
    }
  }
};
</script>

<style lang="less" scoped>
.active {
  background-color: rgba(36, 109, 235, 0.4);
}
//设置了行高和字体大小、高度颜色
/deep/.el-menu-item {
  font-size: 14px;
  height: 52px;
  line-height: 52px;
  color: #666666;
  transition: none !important;
}
//子节点选中样式(前面只有一级，后面子级)
/deep/.el-menu-item.is-active,
.el-submenu .el-menu-item.is-active {
  background-color: rgba(36, 109, 235, 0.4) !important;
}
.msgBox {
  width: 340px;
  border-radius: 4px;
  margin: auto;
  .msgBoxitem {
    padding: 20px;
    background: #f7f7fa;
    border-radius: 4px;
    margin-bottom: 20px;
    > div:nth-child(1) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      /* identical to box height, or 157% */
      display: flex;
      align-items: center;
      color: #ff4d4f;
    }
    > div:nth-child(2) {
      display: flex;
      margin: 11px 0;
      justify-content: space-between;
      flex-wrap: wrap;
      > span:nth-child(1) {
        text-align: left;
        line-height: 44px;
      }
      > span:nth-child(2) {
        // width: 150px;
        display: flex;
        margin: 11px 0;
        align-items: center;
        > span:nth-child(1) {
          // width: 60px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          /* identical to box height, or 157% */

          display: flex;
          align-items: center;
          text-align: justify;

          color: #000000;
        }
        > span:nth-child(2) {
          // width: 20px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height, or 157% */
          display: flex;
          align-items: center;
          text-align: justify;
          color: #598fee;
          margin-left: 8px;
        }
        > span:nth-child(3){
          margin-left: 3px;
        }
      }
    }
    > div:nth-child(3) {
      display: flex;
      > span:nth-child(1) {
        width: 90px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        // line-height: 22px;
        /* identical to box height, or 157% */
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: justify;
        color: #666666;
      }
      > span:nth-child(2) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        // line-height: 22px;
        /* identical to box height, or 157% */

        display: flex;
        align-items: center;
        text-align: justify;

        color: #666666;
      }
    }
  }
}
/deep/.el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: -25px;
  padding: 14px;
}

/deep/.el-drawer.rtl {
  height: 88%;
  top: 101px;
  bottom: 0;
  right: 20px;
  margin-right: 20px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  // line-height: 22px;
  margin-left: 20px;
  color: #000000;
  span {
    // width: 100%;
  }
}
// /deep/.el-icon {
//   display: none;
// }

.container {
  /*实现全面布局*/
  height: 100vh;
  /deep/.header {
    background: #001529;
    // color: #333;
    // text-align: center;
    // background: red;
    .headerDiv {
      width: 100%;
      height: 100px;
      display: flex;
      // background: pink;
      .logo {
        height: 100px;
        display: flex;
        align-items: center;
        img {
          height: 60px;
          vertical-align: middle;
        }
      }
      .tabImg {
        height: 100%;
        display: flex;
        align-items: center;
        .tabImgs {
          display: flex;
          img {
            width: 100px;
            height: 100px;
            cursor: pointer;
            margin: 20px;
          }
          >div{
            &:last-child{
              display: flex;
              flex-direction: column;
              align-items: center;
              img{
                width: 5.2rem;
                height: 5.2rem;
                margin-top:3.2rem;
                margin-bottom: 0.7rem;
              }
              div{
                color:#fff;
                font-size: 1.4rem;
              }
            }
          }
        }
      }
      .headerRight {
        height: 100%;
        cursor: pointer;
        flex: auto;
        // display: flex;
        .headerRightTop {
          width: 100%;
          height: 50px;
          padding: 5px;
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #fed5b1;
          > div:nth-child(2) {
            margin: 0 19px;
          }
        }
        .headerRightBotton {
          margin-top: 1.5rem;
          display: flex;
          justify-content: flex-end;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #ffffff;
          >div{
            &:nth-child(1){
              margin-right: 1.7rem;
            }
            &:nth-child(2){
              margin-right: 0.5rem;
            }
          }
        }
      }
    }
  }

  /deep/.el-aside {
    background: #2a354d;
    color: #333;
    width: 260px;
  }
  .el-main {
    background-color: #e9eef3;
    color: #333;
    text-align: left;
  }
}
/deep/.el-drawer {
  width: 38.0rem !important;
  right: 0 !important;
}
/deep/.el-drawer__header{
  text-align: center;
  font-size: 1.6rem;
  color: #000;
  font-family: OPPOSans;
}
.navDataAc{
  width: 100px !important;
  height: 100px !important;
  cursor: pointer;
  margin: 20px !important;
}
</style>
